import React, { useContext, useEffect, useState } from "react";
import { Modal, Box, Typography } from "@mui/material";
import NeoButton from "./NeoButton"; // your custom button
import {
  getCraftableCount,
  getCraftAmount,
  handleCraft,
  handleDestroy,
} from "../@shared/game/cardPackEngine";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useAuthStore } from "../@shared/store/useAuthStore";
import { motion, AnimatePresence } from "framer-motion";
import InfinityCard from "../components/InfinityCard"; // ensure this component is web‑compatible
import CraftedCardModal from "./CraftedCardModal";
import { MainContext } from "../App";
import CharacterCard from "./CharacterCard";
import Toast from "./Toast";

const styles = {
  cardContainer: {
    position: "absolute",
    zIndex: 10000,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "60%",
    width: "fit-content",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    // You can add padding/margin as needed
  },
  buttonRow: {
    display: "flex",
    flexFlow: "row",
    marginTop: "20px",
    gap: "20px",
    justifyContent: "space-evenly",
    width: "100%",
  },
  bottomSheet: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#371793",
    padding: "20px",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    zIndex: 99999,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  sheetTitle: {
    fontSize: "20px",
    color: "#fff",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  incrementRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "20px",
    width: "100%",
  },
  incrementButton: {
    width: "58px",
    display: "flex",
    justifyContent: "center",
  },
};

const ViewCardModal = ({ card, usedToCraft, craftTarget, onClose, totalCards }) => {
  const { Theme, setMessage, setError } = useContext(MainContext);
  const { userData } = useAuthStore();
  const [showCraftSheet, setShowCraftSheet] = useState(false);
  const [craftCount, setCraftCount] = useState(1);
  const [craftedCard, setCraftedCard] = useState(null);
  const [showDestroySheet, setShowDestroySheet] = useState(false);
  const [destroyCount, setDestroyCount] = useState(1);
  // const [topDeckValue, setTopDeckValue] = useState(null);

  const handleFindDeck = () => {
    if (!userData?.decks || !Array.isArray(userData.decks)) return null;

    let topDeck = null;
    let maxCount = 0;

    userData.decks.forEach((deck) => {
      const cardCount = deck.cards.filter((c) => c.id === card.id).length;

      if (cardCount > maxCount) {
        maxCount = cardCount;
        topDeck = deck;
      }
    });

    console.log("🏆 Deck with highest count of this card:", topDeck?.name);
    console.log("Max count:", maxCount);
    return maxCount;
  };
  const topDeckValue = handleFindDeck()

  // useEffect(() => {

  //   if (card && !topDeckValue) {
  //     handleFindDeck()
  //   }

  // }, [card, topDeckValue]);

  console.log("Card:", card);

  console.log("Used to craft:", usedToCraft);

  console.log("Craft target:", craftTarget);
  if (!card) return null;

  return (
    <Modal open={card !== null} onClose={onClose} closeAfterTransition>
      <AnimatePresence>
        {/* Background overlay */}
        <motion.div
          onClick={onClose}
          key="background"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.7)",
            zIndex: 1300,
          }}
        />
        <Toast
          onFinish={() => { }}
          timeTilClose={3000}
        />
        {/* Card container with zoom-in/zoom-out effect */}
        <motion.div
          key="cardContainer"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1, transform: "translate(-50%, -50%)" }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ type: "spring", damping: 10 }}
          style={styles.cardContainer}
        >
          {card.type === "Infinity" ? (
            <InfinityCard
              {...card}
              heightPer={100}
              containerHeight={window.innerWidth >= 900 ? 460 : 300}
              borderPx={5}
              shineEffect={true}
              showAmountOwned={true}
            />
          ) : (
            <CharacterCard
              {...card}
              heightPer={100}
              containerHeight={window.innerWidth >= 900 ? 460 : 300}
              borderPx={5}
              shineEffect={true}
              showAmountOwned={true}
            />
          )}
          <Box sx={{ ...styles.buttonRow, width: "100%" }}>
            {usedToCraft && craftTarget && (
              <NeoButton
                text="Craft"
                color={Theme.palette.primary.main}
                width={48}
                onClick={() => setShowCraftSheet(true)}
              />
            )}
            {(card.type === "Infinity" && totalCards > 40) && (
              <NeoButton
                text="Destroy for XP"
                color={Theme.palette.secondary.main}
                width={54}
                onClick={() => setShowDestroySheet(true)}
              />
            )}
          </Box>
        </motion.div>

        {/* Craft bottom sheet */}
        {showCraftSheet && craftTarget && (
          <motion.div
            key="craftSheet"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.3 }}
            style={styles.bottomSheet}
          >
            <Typography sx={styles.sheetTitle}>
              Craft: {craftTarget.name}
            </Typography>
            <InfinityCard
              {...craftTarget}
              heightPer={80}
              containerHeight={220}
              borderPx={4}
            />
            <Typography
              sx={{ color: "#fff", fontWeight: "bold", fontSize: 16, mt: 1 }}
            >
              Amt Owned: {card.amountOwned} | Required To Craft:{" "}
              {getCraftAmount(craftTarget)}
            </Typography>
            <Box sx={styles.incrementRow}>
              <Box sx={styles.incrementButton}>
                <NeoButton
                  isIcon={true}
                  icon={<RemoveIcon fontSize="large" sx={{ color: "#fff" }} />}
                  color="$secondary"
                  width={100}
                  onClick={() => setCraftCount((prev) => Math.max(1, prev - 1))}
                />
              </Box>
              <Typography sx={{ fontSize: 18, color: "#fff", mx: 2 }}>
                {craftCount}
              </Typography>
              <Box sx={styles.incrementButton}>
                <NeoButton
                  isIcon={true}
                  icon={<AddIcon fontSize="large" sx={{ color: "#fff" }} />}
                  color="$primary"
                  onClick={() =>
                    setCraftCount((prev) =>
                      Math.min(getCraftableCount(craftTarget, [card]), prev + 1)
                    )
                  }
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <NeoButton
                text="Cancel"
                color="$secondary"
                width={50}
                onClick={() => setShowCraftSheet(false)}
              />
              <NeoButton
                text="Craft Now"
                color="$primary"
                width={50}
                onClick={async () => {
                  await handleCraft(craftTarget, card, craftCount, userData);
                  setShowCraftSheet(false);
                  setCraftedCard(craftTarget); // Show crafted card animation
                }}
              />
            </Box>
          </motion.div>
        )}

        {/* Destroy bottom sheet */}
        {showDestroySheet && card && (
          <motion.div
            key="destroySheet"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.3 }}
            style={styles.bottomSheet}
          >
            <Typography sx={styles.sheetTitle}>Destroy: {card.name}</Typography>
            <InfinityCard
              {...card}
              heightPer={80}
              containerHeight={220}
              borderPx={4}
            />
            <Box sx={styles.incrementRow}>
              <Box sx={styles.incrementButton}>
                <NeoButton
                  isIcon={true}
                  icon={<RemoveIcon fontSize="large" sx={{ color: "#fff" }} />}
                  color="$secondary"
                  width={100}
                  onClick={() =>
                    setDestroyCount((prev) => Math.max(1, prev - 1))
                  }
                />
              </Box>
              <Typography sx={{ fontSize: 18, color: "#fff", mx: 2 }}>
                {destroyCount}
              </Typography>
              <Box sx={styles.incrementButton}>
                <NeoButton
                  isIcon={true}
                  icon={<AddIcon fontSize="large" sx={{ color: "#fff" }} />}
                  color="$primary"
                  onClick={() => {
                    if (totalCards + destroyCount + 1 < 40) {
                      setMessage("You can't have less than 40 cards.");
                      setError(true);
                      return
                    }

                    if (card.amountOwned - (destroyCount + 1) < topDeckValue) {
                      setMessage("All cards are being used in decks.");
                      setError(true);
                      return

                    }

                    setDestroyCount((prev) =>
                      Math.min(card.amountOwned, prev + 1)
                    )
                  }
                  }
                />
              </Box>
            </Box>
            <Typography sx={{ color: "#fff", mt: 1, fontWeight: "bold" }}>
              🔥 XP Gained: {destroyCount * 10}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <NeoButton
                text="Cancel"
                width={45}
                color="$secondary"
                onClick={() => setShowDestroySheet(false)}
              />
              <NeoButton
                text="Confirm"
                color="$primary"
                width={45}
                onClick={async () => {
                  if (card.amountOwned - destroyCount < topDeckValue) {
                    setMessage("All cards are being used in decks.");
                    setError(true);
                    return

                  }

                  await handleDestroy(card, destroyCount, userData);
                  setShowDestroySheet(false);
                  onClose();
                }}
              />
            </Box>
          </motion.div>
        )}

        {/* Crafted Card Modal */}
        <CraftedCardModal
          visible={!!craftedCard}
          craftedCard={craftedCard}
          onClose={() => {
            setCraftedCard(null);
            onClose();
          }}
        />
      </AnimatePresence>
    </Modal>
  );
};

export default ViewCardModal;
